<template>
  <div class="info-block">
    <h2 class="title small">{{ $t(`Change Password`) }}</h2>
    <form @submit.prevent="resetPassword">
      <div class="input-group">
        <!-- <label for="current-password">{{ $t(`Current password`) }}</label> -->
        <input
          type="password"
          id="current-password"
          v-model="passwordData.currentPassword"
          :placeholder="$t('Current password')"
        />
      </div>
      <div class="input-group">
        <!-- <label for="new-password">{{ $t(`New password`) }}</label> -->
        <input
          type="password"
          id="new-password"
          v-model="passwordData.newPassword"
          :placeholder="$t('New password')"
        />
      </div>
      <div class="input-group">
        <!-- <label for="confirm-password">{{ $t(`Confirm new password`) }}</label> -->
        <input
          type="password"
          id="confirm-password"
          v-model="passwordData.confirmPassword"
          :placeholder="$t('Confirm new password')"
        />
      </div>
      <div class="button-wrapper">
        <button class="red button w-130" type="submit">
          {{ $t("CHANGE") }}
        </button>
      </div>

      <!-- Display the error message from API here -->
      <p v-if="errorMessage" class="error-message">
        {{ errorMessage }}
      </p>

      <!-- Display the success message when password is changed -->
      <p v-if="successMessage" class="success-message">
        {{ successMessage }}
      </p>
    </form>
  </div>
</template>

<script>
export default {
  name: "PasswordReset",
  data() {
    return {
      passwordData: {
        currentPassword: "",
        newPassword: "",
        confirmPassword: "",
      },
      errorMessage: "", // Store error messages from API
      successMessage: "", // Store success messages
    };
  },
  methods: {
    async resetPassword() {
      this.errorMessage = ""; // Clear previous errors
      this.successMessage = ""; // Clear success message

      try {
        const response = await this.$http.post(
          process.env.VUE_APP_API + "user/change-password",
          {
            cur_password: this.passwordData.currentPassword,
            new_password: this.passwordData.newPassword,
            repeat_password: this.passwordData.confirmPassword,
          },
        );

        // If the API response status is OK, display success
        if (response.data.status === "OK") {
          this.successMessage = this.$t("Password changed successfully!");
          this.clearForm();
        }
      } catch (error) {
        if (error.response && error.response.data) {
          // Capture and display the API error message directly
          this.errorMessage =
            this.$t(error.response.data.message) ||
            "An unexpected error occurred.";
        }
      }
    },
    clearForm() {
      this.passwordData.currentPassword = "";
      this.passwordData.newPassword = "";
      this.passwordData.confirmPassword = "";
    },
  },
};
</script>

<style scoped>
.password-reset {
  padding: 52px;
}

.info-block {
  padding: 32px;
  flex: 1;
}

h2 {
  color: white;
  font-family: "Roboto", sans-serif;
  margin-bottom: 46px;
  line-height: 120%;
}

.input-group {
  margin-bottom: 14px;
  max-width: 366px;
}

label {
  display: block;
  margin-bottom: 5px;
  color: #b7b8c1;
  font-family: "Roboto", sans-serif;
}

.error-message {
  color: #ff6464;
  font-size: 12px;
  margin-top: 5px;
}

.success-message {
  color: #6aff64;
  margin-top: 20px;
  text-align: center;
}

.button-wrapper {
  margin-left: auto;
  margin-top: 42px;
  display: flex;
  align-items: center;
}

@media (max-width: 768px) {
  .password-reset {
    padding: 52px 12px 52px;
  }

  .button-wrapper {
    margin: 0 auto;
  }
}
</style>
